/** Where the fake provider log lives: a tab on the Integrations page. The old /fake-provider-logs address redirects here. */
export const TEST_LOGS_PATH = '/settings/integrations/test-logs';
